import axios from "axios";

export const apiURL = process.env.REACT_APP_API_URL + "api";

export const customFetch = axios.create({
  baseURL: apiURL,
});
// export const sendMessage = (data) => {
//   return axios.post(`${apiURL}/message/add`, data);
// };

export const login = (data) => {
  return customFetch.post(`${apiURL}/auth/signin`, data, {
    withCredentials: true,
  });
};

export const signup = (data) => {
  return customFetch.post(`${apiURL}/auth/signup`, data);
};

export const verifyEmail = (token) => {
  return customFetch.put(`${apiURL}/auth/email-verify/${token}`);
};

export const forgetPassword = (data) => {
  return customFetch.post(`${apiURL}/auth/forget-password`, data);
};

export const resetPasswordFp = (data) => {
  return customFetch.put(`${apiURL}/auth/reset-password-fp`, data);
};

export const addCareer = (data) => {
  return customFetch.post(`${apiURL}/career/add`, data);
};

export const addTraining = (data) => {
  return customFetch.post(`${apiURL}/training/add`, data);
};
